export default __webpack_public_path__ + "static/media/icon_bazaar.02236ecd.svg";